/*
 *
 * File JS componente modal cookie
 *
 */

// IMPORT UTILITIES JS
//--------------------------------------------------------------------//

import { setCookie, getCookie } from "../../js/utilities/cookie";

//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./modal-cookie.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const modalCookie = () => {
  let buttonsCloseModal = document.querySelectorAll(".im-modal-cookie__close");
  let blockModal = document.querySelectorAll(".im-modal-cookie");
  let backgroundModal = document.querySelectorAll(
    ".im-modal-cookie__background"
  );

  if (!blockModal.length) return;

  blockModal.forEach((el) => {
    let dataCookieName = el.getAttribute("data-name");
    let delay = parseInt(el.getAttribute("data-delay") * 1000, 10) || 0;
    let timeout = parseInt(el.getAttribute("data-timeout") * 1000, 10) || 0;

    



    if (getCookie(dataCookieName) == null) {
      setTimeout(() => {
        el.classList.add("open");
      }, delay );

      // Close the modal after timeout (if specified)
      if (timeout > 0) {
        setTimeout(() => {
          closeThisModal(el.getAttribute("data-modal"));
        }, delay + timeout); // delay + timeout to account for the opening delay
      }
    }
  });

  buttonsCloseModal.forEach((el) => {
    el.addEventListener("click", function (evt) {
      // evt.preventDefault();
      let dataModal = this.getAttribute("data-modal");
      closeThisModal(dataModal);
    });
  });

  backgroundModal.forEach((element) => {
    element.addEventListener("click", () => {
      let dataModal = element
        .closest(".im-modal-cookie")
        .getAttribute("data-modal");

      closeThisModal(dataModal);
    });
  });

  /**
   *	Funzione per la chiusura di tutti i modal popup
   *
   */
  const closeThisModal = (data) => {
    console.log("closeThisModal", data);

    let modalToClose = document.querySelector(
      '.im-modal-cookie[data-modal="' + data + '"]'
    );

    if (!modalToClose) {
      console.error("Modal not found for data-modal:", data);
      return; // Exit the function if no matching modal is found
    }

    let dataCookieExpire = parseInt(modalToClose.getAttribute("data-expire"));

    let dataCookieName = modalToClose.getAttribute("data-name");

    document.body.style.overflow = "";
    modalToClose.classList.remove("open");

    setCookie(dataCookieName, "true", dataCookieExpire);
  };

  /**
   *	Funzione per la chiusura di tutti i modal popup
   *
   */
  const closeAllModal = () => {
    let allModal = document.querySelectorAll(".im-modal-cookie");

    allModal.forEach((el) => {
      let dataModal = el.getAttribute("data-modal");
      closeThisModal(dataModal);
    });
  };

  /**
   *	Funzione di gestione chiusura dei modal popup digitando ESC
   *
   */
  const closeAllOnKeyup = (e) => {
    if (e.keyCode === 27) {
      closeAllModal();
    }
  };

  document.addEventListener("keyup", closeAllOnKeyup);
};

export default modalCookie;

//--------------------------------------------------------------------//
